import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      {/* Header */}
      <header className="bg-[#0B1E36] text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-white/70 hover:text-white mb-6 transition-colors"
            data-testid="back-to-home"
          >
            <ArrowLeft className="w-5 h-5" />
            Torna alla Home
          </Link>
          <h1 className="text-3xl md:text-4xl font-bold">Privacy Policy</h1>
          <p className="text-white/70 mt-2">Ultimo aggiornamento: Gennaio 2025</p>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 py-12 md:py-16">
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-[#E2E8F0]">
          <div className="prose prose-lg max-w-none">
            <section className="mb-10">
              <h2 className="text-2xl font-bold text-[#0B1E36] mb-4">1. Titolare del Trattamento</h2>
              <p className="text-[#64748B] leading-relaxed">
                Il Titolare del trattamento dei dati personali è Finestre e Colore, con sede legale in Italia.
                <br />
                Email: <a href="mailto:info@finestreecolore.it" className="text-[#007AFF] hover:underline">info@finestreecolore.it</a>
                <br />
                Telefono: +39 327 282 3064
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-[#0B1E36] mb-4">2. Tipologie di Dati Raccolti</h2>
              <p className="text-[#64748B] leading-relaxed mb-4">
                Tra i Dati Personali raccolti da questo sito, in modo autonomo o tramite terze parti, ci sono:
              </p>
              <ul className="list-disc pl-6 text-[#64748B] space-y-2">
                <li>Nome e cognome</li>
                <li>Indirizzo email</li>
                <li>Numero di telefono</li>
                <li>Dati relativi alla richiesta di preventivo (tipo di serramento, dimensioni, quantità)</li>
                <li>Cookie e dati di utilizzo</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-[#0B1E36] mb-4">3. Finalità del Trattamento</h2>
              <p className="text-[#64748B] leading-relaxed mb-4">
                I Dati dell'Utente sono raccolti per le seguenti finalità:
              </p>
              <ul className="list-disc pl-6 text-[#64748B] space-y-2">
                <li>Rispondere alle richieste di contatto e preventivo</li>
                <li>Fornire informazioni sui nostri servizi</li>
                <li>Migliorare l'esperienza di navigazione sul sito</li>
                <li>Adempiere agli obblighi di legge</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-[#0B1E36] mb-4">4. Base Giuridica del Trattamento</h2>
              <p className="text-[#64748B] leading-relaxed">
                Il trattamento dei dati personali si basa sul consenso dell'utente, espresso al momento 
                della compilazione dei moduli di contatto o richiesta preventivo. Per alcune finalità, 
                il trattamento può essere necessario per l'esecuzione di un contratto o per adempiere 
                a obblighi legali.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-[#0B1E36] mb-4">5. Modalità di Trattamento</h2>
              <p className="text-[#64748B] leading-relaxed">
                I dati personali sono trattati con strumenti automatizzati per il tempo strettamente 
                necessario a conseguire gli scopi per cui sono stati raccolti. Specifiche misure di 
                sicurezza sono osservate per prevenire la perdita dei dati, usi illeciti o non corretti 
                ed accessi non autorizzati.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-[#0B1E36] mb-4">6. Conservazione dei Dati</h2>
              <p className="text-[#64748B] leading-relaxed">
                I dati personali saranno conservati per il tempo necessario al conseguimento delle 
                finalità per le quali sono trattati, e comunque non oltre i termini di legge. 
                I dati relativi alle richieste di preventivo saranno conservati per un periodo 
                massimo di 24 mesi.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-[#0B1E36] mb-4">7. Diritti dell'Interessato</h2>
              <p className="text-[#64748B] leading-relaxed mb-4">
                L'utente può esercitare i seguenti diritti:
              </p>
              <ul className="list-disc pl-6 text-[#64748B] space-y-2">
                <li>Diritto di accesso ai propri dati personali</li>
                <li>Diritto di rettifica dei dati inesatti</li>
                <li>Diritto alla cancellazione dei dati ("diritto all'oblio")</li>
                <li>Diritto di limitazione del trattamento</li>
                <li>Diritto alla portabilità dei dati</li>
                <li>Diritto di opposizione al trattamento</li>
                <li>Diritto di revocare il consenso in qualsiasi momento</li>
              </ul>
              <p className="text-[#64748B] leading-relaxed mt-4">
                Per esercitare i propri diritti, l'utente può inviare una richiesta a: 
                <a href="mailto:info@finestreecolore.it" className="text-[#007AFF] hover:underline ml-1">info@finestreecolore.it</a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1E36] mb-4">8. Modifiche alla Privacy Policy</h2>
              <p className="text-[#64748B] leading-relaxed">
                Il Titolare si riserva il diritto di apportare modifiche alla presente privacy policy 
                in qualunque momento, dandone informazione agli Utenti su questa pagina. Si prega 
                di consultare regolarmente questa pagina per verificare eventuali aggiornamenti.
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Simple Footer */}
      <footer className="bg-[#0B1E36] text-white py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} Finestre e Colore. Tutti i diritti riservati.
          </p>
        </div>
      </footer>
    </div>
  );
}
